export default __webpack_public_path__ + "static/media/user_placeholder.73a0bc1f.png";